import { useContext } from 'react';
import { ToastNotificationContext } from './notification_toast.provider';
export const useToastNotification = () => {
    const context = useContext(ToastNotificationContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
//# sourceMappingURL=use_toast_notification.hook.js.map